const educationContent = 
    [
        {
            "company": "Oregon State University",
            "location": "Corvallis, OR",
            "duration": "Jan 2023 - March 2025",
            "extra": "Expected BS 2020, MS 2021",
            "roles": [
                {
                    "title": "Bachelor of Science in Computer Science",
                    "description": [
                        
                        "I received my second Bachelor's degree from Oregon State University. I enjoyed every moment of studying Computer Science since starting my degree. Oregon State's curriculum emphasizes positive design habits for readable, extensible code and thorough tests. The school provides fundamental courses and electives that have improved my skills for software engineering. In addition, numerous classes required us to work in groups, and promoted pair programming which benefitted students to collaborate and create the best quality code.",
            
                    ],
                }
            ],
        },
        {
            "company": "Ramapo College of New Jersey",
            "location": "Mahwah, NJ",
            "duration": "Sep 2018 - May 2022",
            "roles": [
                {
                    "title": "Bachelor of Science in Biology",
                    "description": ["I hold a Bachelor's degree in Biology, which nurtured my analytical skills and deepened my appreciation for life's complexities. As a child of a Biology and Chemistry teacher, I grew up loving Biology and all of the its applications. Studying Biology also lead me into Computer Science, when I was required to utilize python for DNA scripting and studying genomics. This background in scientific inquiry and problem-solving enriches my approach to software development, enabling me to tackle challenges with precision and creativity."],

                    
                }
            ],
            "skills": [
             
            ]
        }
    ]

export default educationContent;